<template>
  <v-app id="app">
    <app-navigation :currentUser="currentUser" app></app-navigation>
    <app-header :currentUser="currentUser" app></app-header>
    <v-content>
      <v-container fluid grid-list-xl :fill-height="!currentUser" v-bind:class="{ 'no-logged' : !currentUser }">
        <app-loading v-show="appLoading"></app-loading>
        <router-view v-show="!appLoading" />
      </v-container>
    </v-content>
    <!-- <v-footer v-if="currentUser" class="text-center" light app>
      <v-layout id="overview" align-center justify-center>
        © Carlos Duque, {{ new Date().getFullYear() }}. Todos os direitos reservados.
      </v-layout>
    </v-footer> -->
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" top>
      {{ snackbar.message }}
      <v-btn dark flat @click.native="snackbar.show = false">
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import router from '@/router'
import AppHeader from '@/modules/AppHeader'
import AppNavigation from '@/modules/AppNavigation'
import AppLoading from '@/modules/AppLoading'
import axios from 'axios'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'

export default {
  name: 'App',
  data: () => ({
    currentUser: null,
    appLoading: false,
    snackbar: {
      color: '',
      show: false,
      message: ''
    }
  }),

  methods: {
    async checkIfIsLogged () {
      EventBus.$emit('appLoading', false)
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
      const routeName = this.$route.name
      let currentUserIsAdmin
      let currentSession

      if (this.currentUser) {
        currentUserIsAdmin = this.currentUser.roles.indexOf('admin') !== -1
        EventBus.$emit('loadAlertNotifications')
        currentSession = await Auth.currentSession()
      }

      if (currentSession && currentSession.idToken.jwtToken) {
        axios.defaults.headers.common['Authorization'] = currentSession.idToken.jwtToken
        localStorage.setItem('currentToken', currentSession.idToken.jwtToken)
      }

      if (!this.currentUser && routeName !== 'LoginForgot' && routeName !== 'LoginNewPassword') {
        router.push({ name: 'Login' })
      } else if (this.currentUser && this.currentUser.token) {
        if ((this.currentUser.status === 'pending' || this.currentUser.status === 'confirmed') && routeName !== 'Account' && !currentUserIsAdmin) {
          router.push({ name: 'Account', params: { completeAccount: true } })
        } else if (routeName === 'Login') {
          router.push('/')
        }
      }
    },

    checkAppLoading () {
      EventBus.$on('appLoading', data => {
        this.appLoading = data
      })
    },

    checkSnackbar () {
      EventBus.$on('showSnackbar', data => {
        this.snackbar.message = data.message
        this.snackbar.show = true
        EventBus.$emit('appLoading', false)

        if (data.color) {
          this.snackbar.color = data.color
        }
      })
    }
  },

  watch: {
    '$route': 'checkIfIsLogged'
  },

  created () {
    this.checkAppLoading()
    this.checkIfIsLogged()
    this.checkSnackbar()
  },

  components: {
    'app-header': AppHeader,
    'app-navigation': AppNavigation,
    'app-loading': AppLoading
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue